import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import TaskAltIcon from '@mui/icons-material/TaskAlt';

import ProgressTracker from '@ui-parts/ProgressTracker';
import MessageArea from '@ui-parts/MessageArea';
import LinkButton from '@ui-parts/LinkButton';

import { PROGRESS_TRACKER_LABELS, PROGRESS_TYPE, USER_REGISTRATION_PROGRESSES } from '~/constants';
import { PALETTE } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';

const MessageAreaWrapper = styled.div`
  max-width: 504px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 58px auto 0;
`;

const StyledTaskAltIcon = styled(TaskAltIcon)`
  color: ${PALETTE.text.primary};
  font-size: 4rem;
`;

const VerifyCompleted = () => {
  const { t } = useTranslation();

  return (
    <>
      <ProgressTracker
        width="618px"
        labels={(PROGRESS_TRACKER_LABELS as Record<string, Array<string>>)[
          PROGRESS_TYPE.USER_REGISTRATION
        ].map((label) => t(label))}
        currentNum={USER_REGISTRATION_PROGRESSES[ROUTES.USER.SIGNUP_VERIFY_COMPLETED]}
      />

      <MessageAreaWrapper>
        <MessageArea
          title={t('userMessage.register.title')}
          message={t('userMessage.register.message')}
          button={
            <LinkButton
              label={t('userMessage.register.link')}
              variant="outlined"
              href={ROUTES.USER.SURVEY_REGISTER_TYPE_SELECTION}
              styles={{ width: 'auto' }}
            />
          }
        >
          <StyledTaskAltIcon />
        </MessageArea>
      </MessageAreaWrapper>
    </>
  );
};

export default VerifyCompleted;
